<template>
    <div class="list-responses">
        <Response v-if="responses && responses.length !== 0" :key="responses[0].uuid" :response="responses[0]" @updateResponse="updateResponse"
                  :user="user" @onSubmit="onSubmit"
                  :formEditResponseShow="formEditResponseShow"
                  @openEditResponseForm="openEditResponseForm"
                  @deleteEntity="deleteEntity"
                  @closeForm="closeForm"></Response>
        <div v-if="responses.length > 1">
            <div v-show="showMore">
                <Response v-for="(item) in responses.slice(1)" :key="item.uuid" :response="item" :user="user"
                          :formEditResponseShow="formEditResponseShow"
                          @updateResponse="updateResponse"
                          @markModerate="markModerate"
                          @onSubmit="onSubmit"
                          @openEditResponseForm="openEditResponseForm"
                          @deleteEntity="deleteEntity"
                          @closeForm="closeForm">
                </Response>
            </div>
            <div v-if="!showMore" class="list-responses__more" @click="showListResponses">
                <div class="list-responses__more-icon"></div>
                <span>{{ declinationOfNum(responses.length - 1) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import Response from "@/components/Response";

export default {
    name: "ListResponses",
    props: {
        responses: {
            type: Array,
            require: true
        },
        type: String,
        user    : {
          type   : Object,
          require: true
        },
        formEditResponseShow: {
          type: [Boolean, String]
        }
    },
    components: { Response },
    data() {
        return {
            showMore: false,
        }
    },
    methods: {
        declinationOfNum(number) {
            let index = 0,
                decCases = [2, 0, 1, 1, 1, 2];
            let titles = ['ответ', 'ответа', 'ответов'];
            index = number % 100 > 4 && number % 100 < 20 ? 2 : decCases[Math.min(number % 10, 5)];
            return `Еще ${number} ${titles[index]}`;
        },
        showListResponses() {
            this.showMore = true;
        },
        updateResponse(object){
            if (this.type === 'review') {
                this.$emit('updateResponseToReview', object)
            } else if (this.type === 'question') {
                this.$emit('updateResponseToQuestion', object)

            }
        },
        markModerate(uuid) {
          this.$emit('markModerate', uuid);
        },
        onSubmit(response, uuid, showAddRespons) {
            this.$emit('onSubmit', response, uuid, showAddRespons)
        },
        openEditResponseForm(uidInstance) {
            this.$emit('openEditResponseForm', uidInstance)
        },
        closeForm(uidInstance) {
          this.$emit('closeForm', uidInstance);
        },
        deleteEntity(uidInstance) {
          this.$emit('deleteEntity', uidInstance)
        }
    },
}
</script>

<style scoped>

</style>